import React from 'react';
import PageState from './PageState';

class AppErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, info) {
        console.error('[AppErrorBoundary] Unhandled UI error:', error, info);
    }

    handleRetry = () => {
        this.setState({ hasError: false });
        window.location.reload();
    };

    render() {
        if (this.state.hasError) {
            return (
                <PageState
                    variant="fatal"
                    title="Une erreur a interrompu l'application"
                    message="Rechargez la page pour rétablir la lecture. Si le problème persiste, réessayez dans quelques instants."
                    actionLabel="Recharger"
                    onAction={this.handleRetry}
                    secondaryLabel="Accueil"
                    onSecondaryAction={() => window.location.assign('/')}
                />
            );
        }

        return this.props.children;
    }
}

export default AppErrorBoundary;
